export enum DataGridLinkVariant {
  STANDARD = 'standard',
  PRIMARY = 'primary',
}
